import * as AirportStyles from './components/Airport.css';
import * as HeaderStyles from './components/Header/Header.css';
export default {
    AirportStyles,
    HeaderStyles
};
